import React from "react";
import { TableHeader } from "../../commons";
import RecruitmentTrackerTableData from "./RecruitmentTrackerTableData";
import { RECRUITMENT_MODULE_HEADERS } from "../../../constant/hrms/recruitmentModule/recruiterModuleConst";
type AppProps = {
  history: any;
  data: any;
  handleEditRecruitmentTracker?: (data: any) => void;
  handleDeleteRecruitmentData?: (data: string) => void;
  isDeleteRecruitmentTrackerPresent?: boolean;
  isEditRecruitmentTrackerPresent?: boolean;
  activeTab: string;
};
const RecruitementTrackerTable = ({
  history,
  data,
  handleEditRecruitmentTracker,
  handleDeleteRecruitmentData,
  isDeleteRecruitmentTrackerPresent,
  isEditRecruitmentTrackerPresent,
  activeTab,
}: AppProps) => {
  return (
    <>
      <div className="jobsType" style={{ overflowX: "scroll" }}>
        <table className="table thead-light table-bordered">
          <thead className="sticky-table-header">
            <TableHeader tableHeader={RECRUITMENT_MODULE_HEADERS} />
          </thead>
          <tbody>
            <RecruitmentTrackerTableData
              data={data}
              header={RECRUITMENT_MODULE_HEADERS}
              history={history}
              handleEditRecruitmentTracker={handleEditRecruitmentTracker}
              handleDeleteRecruitmentData={handleDeleteRecruitmentData}
              isEditRecruitmentTrackerPresent={isEditRecruitmentTrackerPresent}
              isDeleteRecruitmentTrackerPresent={
                isDeleteRecruitmentTrackerPresent
              }
              activeTab={activeTab}
            />
          </tbody>
        </table>
      </div>
    </>
  );
};

export default RecruitementTrackerTable;
